import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sizePage } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ContractService {

  constructor(private readonly http: HttpClient) { }

  GetContractList(pData: any, page: number): Observable<any> {
    page--;
    let url = '/contract/page/'
      + page + '?size=' + sizePage
      + '&' + pData;
    return this.http.get<any>(url,
      { observe: 'response' });
  }

  GetTagsList(): Observable<any> {
    return this.http.get<any>('/contract/tags', { observe: 'response' });
  }

  GetContractDetail(pData: string): Observable<any> {
    return this.http.get<any>('/contract/' + pData, { observe: 'response' });
  }

  CreateContractDetail(pData: any): Observable<any> {
    return this.http.post<any>('/contract/',
      pData, { observe: 'response' });
  }

  EditContractDetail(pId: string, pData: any): Observable<any> {
    console.log("EditContractDetail", pId, pData);
    return this.http.put<any>('/contract/' + pId, pData, { observe: 'response' });
  }

  DeleteContractDetail(pId: number): Observable<any> {
    let _parameters = pId;
    return this.http.delete<any>('/contract/' +
      _parameters, { observe: 'response' });
  }

  GetPDFFileClient(externalClientId: string, documentSignType: string) {
    const url = "/client/document/" + documentSignType + "/" + externalClientId;
    console.log("GetPDFFileClient", url);
    return this.http.get(url, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  GetASN1Client(externalClientId: string, documentSignType: string) {
    const url = "/client/document/asn/" + documentSignType + "/" + externalClientId;
    console.log("GetASN1Client", url);
    return this.http.get(url, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  GetExpedientClient(externalClientId: string, documentSignType: string) {
    const url = `/client/expedient/${externalClientId}`;
    console.log("GetExpedientClient", url);
    return this.http.get(url, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

}
